/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockOpenIcon16Solid = forwardRef('SecurityLockOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0a4 4 0 0 0-4 4v1H3.5A2.5 2.5 0 0 0 1 7.5v4A2.5 2.5 0 0 0 3.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-4A2.5 2.5 0 0 0 10.5 5H10V4a2 2 0 0 1 2-2h.1c1.05 0 1.9.85 1.9 1.9V4a1 1 0 1 0 2 0v-.1A3.9 3.9 0 0 0 12.1 0H12ZM7.75 9.75a1.25 1.25 0 1 0-1.5 0V11a.75.75 0 0 0 1.5 0V9.75Z" })));
});
